import React, { useEffect, useState } from 'react';
import { getBasicDetailsData, getBasicDetailsLoading, getBasicDetailsSel, getCurrentChild } from 'src/shared/redux-state/src';
import { store, useAppDispatch, useAppSelector } from '../../services/store';
import { ChildrenStoreData, BasicDetailsType } from 'src/shared/types/src';
import ProfileBaseScreen from './ProfileBaseScreen';
import { FullScreenLoader } from 'src/app/components';

const BasicDetailsScreen = () => {

    const dispatch = useAppDispatch();

    const basicDetails: BasicDetailsType = useAppSelector(getBasicDetailsSel);
    const basicDetailsLoading: boolean = useAppSelector(getBasicDetailsLoading);
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        console.log("fetching basic details");
        if (!basicDetails || Object.keys(basicDetails).length == 0) {
            dispatch(getBasicDetailsData({ reduxStore: store, child: currentChild }))
        };
    }, [currentChild]);

    const refetchData = () => {
        dispatch(getBasicDetailsData({ reduxStore: store, child: currentChild }))
    };

    return (
        <ProfileBaseScreen>
            {basicDetailsLoading ? <FullScreenLoader /> :
                <div>

                    {basicDetails?.childDetails?.name?.visible && (
                        <div className='form-group mg-t-25'>
                            <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.name?.label || 'Name'}</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.name?.value || ''}</div>
                        </div>
                    )}

                    {basicDetails?.childDetails?.dob?.visible && (
                        <div className='form-group mg-t-25'>
                            <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.dob?.label || 'Date Of Birth'}</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.dob?.value || ''}</div>
                        </div>
                    )}

                    <div className='row'>
                        {basicDetails?.childDetails?.legalGender?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.legalGender?.label || 'Legal Gender'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.legalGender.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.genderIdentity?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.genderIdentity?.label || 'Gender Identity'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.genderIdentity?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='row'>
                        {basicDetails?.childDetails?.preferredName?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.preferredName?.label || 'Preferred Name'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.preferredName.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.pronouns?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.pronouns?.label || 'Pronouns'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.pronouns?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='row'>
                        {basicDetails?.childDetails?.room?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.room?.label || 'Room'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.room.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.keyPerson?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.keyPerson?.label || 'Key Person'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.keyPerson?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    {basicDetails?.childDetails?.address?.visible && (
                        <div className='form-group mg-t-25'>
                            <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.address?.label || 'Address'}</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.address?.value || ''}</div>
                        </div>
                    )}

                    <div className='row'>
                        {basicDetails?.childDetails?.nationality?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.nationality?.label || 'Nationality(s)'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.nationality?.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.ethnicity?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.ethnicity?.label || 'Ethnicity'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.ethnicity?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    {basicDetails?.childDetails?.religion?.visible && (
                        <div className='form-group mg-t-25'>
                            <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.religion?.label || 'Religion'}</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.religion?.value || ''}</div>
                        </div>
                    )}

                    <div className='row'>
                        {basicDetails?.childDetails?.firstLanguage?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.firstLanguage?.label || 'First Language'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.firstLanguage?.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.additionalLanguage?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.additionalLanguage?.label || 'Additional Language'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.additionalLanguage?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    {basicDetails?.childDetails?.startDate?.visible && (
                        <div className='form-group mg-t-25'>
                            <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.startDate?.label || 'Start Date'}</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.startDate?.value || ''}</div>
                        </div>
                    )}

                    {basicDetails?.childDetails?.paymentDetails && Object.keys(basicDetails?.childDetails?.paymentDetails).length > 0 && (
                        <div className='mg-t-25 border border-gray-200 pd-20 rounded-2'>
                            <p className='fs-12 fw-bold text-black mb-0'>Invoice and Payment Details</p>

                            {basicDetails?.childDetails?.paymentDetails?.paymentMode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.paymentMode?.label || 'Payment Mode'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.paymentMode?.value || ''}</div>
                                </div>
                            )}

                            {basicDetails?.childDetails?.paymentDetails?.underTwoYearCode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.underTwoYearCode?.label || 'Under Two Year Funding Code'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.underTwoYearCode?.value || ''}</div>
                                </div>
                            )}

                            {basicDetails?.childDetails?.paymentDetails?.twoYearCode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.twoYearCode?.label || 'Two Year Funding Code'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.twoYearCode?.value || ''}</div>
                                </div>
                            )}

                            {basicDetails?.childDetails?.paymentDetails?.twoYearFundingCode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.twoYearFundingCode?.label || 'Two Year Funding Code (Working parents/carers)'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.twoYearFundingCode?.value || ''}</div>
                                </div>
                            )}

                            {basicDetails?.childDetails?.paymentDetails?.extendedEntitlementCode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.extendedEntitlementCode?.label || 'Extended Entitlement Code'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.extendedEntitlementCode?.value || ''}</div>
                                </div>
                            )}

                            {basicDetails?.childDetails?.paymentDetails?.taxFreeChildcareCode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.taxFreeChildcareCode?.label || 'Tax-Free Childcare Code'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.taxFreeChildcareCode?.value || ''}</div>
                                </div>
                            )}

                            {basicDetails?.childDetails?.paymentDetails?.voucherCode?.visible && (
                                <div className='form-group mg-t-25'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.paymentDetails?.voucherCode?.label || 'Voucher Code'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.paymentDetails?.voucherCode?.value || ''}</div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className='row'>
                        {basicDetails?.childDetails?.socialWorker?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.socialWorker.label || 'Social Worker'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.socialWorker?.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.socialWorkerContact?.visible && (
                            <div className='col-6 mg-t-25'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.socialWorkerContact?.label || 'Social Worker Contact'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.socialWorkerContact?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='row'>
                        {basicDetails?.childDetails?.schoolName?.visible && (
                            <div className='mg-t-25 col-6'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.schoolName.label || 'School Name'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.schoolName?.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.schoolClass?.visible && (
                            <div className='mg-t-25 col-6'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.schoolClass?.label || 'School Class'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.schoolClass?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='row'>
                        {basicDetails?.childDetails?.schoolTeacher?.visible && (
                            <div className='mg-t-25 col-6'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.schoolTeacher.label || 'School Teacher'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.schoolTeacher?.value || ''}</div>
                                </div>
                            </div>
                        )}

                        {basicDetails?.childDetails?.schoolPhone?.visible && (
                            <div className='mg-t-25 col-6'>
                                <div className='form-group'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.schoolPhone?.label || 'School Phone'}</div>
                                    <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.schoolPhone?.value || ''}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    {basicDetails?.childDetails?.schoolCollectionPassword?.visible && (
                        <div className='form-group mg-t-25'>
                            <div className='form-label text-gray-100 mb-1 fs-12'>{basicDetails?.childDetails?.schoolCollectionPassword.label || 'School Collection Password'}</div>
                            <div className='form-control read-only-control d-flex align-items-center'>{basicDetails?.childDetails?.schoolCollectionPassword?.value || ''}</div>
                        </div>
                    )}

                </div>
            }
        </ProfileBaseScreen>
    )
};

export default BasicDetailsScreen;